{
  "name": "const-credit-fe",
  "version": "0.0.1-4531df45.0",
  "scripts": {
    "watch": "ng test",
    "build": "./scripts/version.sh && ng build --output-hashing all",
    "lint": "ng lint",
    "ng": "ng",
    "install": "cp ./package.json ./src/assets",
    "start": "ng serve --ssl --host localhost.sparbanken.me",
    "style-lint": "stylelint  src/**/*.scss --fix",
    "test": "ng test --watch=false --code-coverage"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.1.1",
    "@angular/common": "^21.1.1",
    "@angular/compiler": "^21.1.1",
    "@angular/core": "^21.1.1",
    "@angular/forms": "^21.1.1",
    "@angular/platform-browser": "^21.1.1",
    "@angular/platform-browser-dynamic": "^21.1.1",
    "@angular/router": "^21.1.1",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1"
  },
  "devDependencies": {
    "@angular/build": "^21.1.1",
    "@angular/cdk": "^21.1.1",
    "@angular/cli": "^21.1.1",
    "@angular/compiler-cli": "^21.1.1",
    "@angular/material": "^21.1.1",
    "@sparbanken-syd/auth-backend": "^2.5.3",
    "@sparbanken-syd/const-credit-be": "next",
    "@sparbanken-syd/personnummer": "^3.0.1",
    "@sparbanken-syd/sparbanken-syd-bankid": "^21.0.1",
    "@sparbanken-syd/sparbanken-syd-qr": "^21.0.0",
    "@sparbanken-syd/sparbanken-syd-theme": "^21.1.2",
    "@sparbanken-syd/sparbanken-syd-theme-m3": "^21.1.1",
    "@types/jasmine": "^5",
    "angular-eslint": "^21.1.0",
    "eslint": "^9.39.2",
    "jasmine-core": "^5",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "postcss": "^8.5.6",
    "puppeteer": "^24.36.0",
    "stylelint": "^17.0.0",
    "stylelint-config-standard-scss": "^17.0.0",
    "typescript": "~5.9.3",
    "typescript-eslint": "^8.54.0"
  }
}
